import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: {
      xs: '16px 12px',
      md: '32px',
    },
    borderRadius: '16px',
    border: '1px solid',
    maxWidth: { xs: '324px', md: '424px' },
    gap: '32px',
    position: 'relative',
    zIndex: 1,
    '&:hover .content-section': {
      transform: 'scale(1.01)',
      transition: '0.5s',
      zIndex: 2,
    },
  },

  infoWrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    height: '48px',
    minWidth: '48px',
    width: 'fit-content',
    display: 'flex',
    marginTop: '3px',
    borderRadius: '50%',
  },
  location: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },
  icon: {
    height: '36px',
    width: '36px',
  },
  linkedIcon: {
    height: '32px',
    width: '32px',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
